import React from "react";

const Dropdown = ({ 
  label, 
  value, 
  onChange, 
  options = [], 
  placeholder = "", 
  className = "",
  labelClassName = "",
  selectClassName = "",
  name = "",
  disabled = false,
  required = false,
  keyField = "id",
  valueField = "value",
  labelField = "label"
}) => {
  return (
    <div className={`att-field ${className}`}>
      {label && (
        <label className={`att-label ${labelClassName}`}>
          {label}{required && <span style={{ color: 'red' }}>*</span>}
        </label>
      )}
      <select 
        value={value} 
        onChange={onChange}
        name={name}
        disabled={disabled}
        className={selectClassName}
      >
        <option value=''>{placeholder}</option>
        {options.map((option, idx) => {
          // Handle both object and primitive array options
          const key = typeof option === 'object' ? option[keyField] || idx : idx;
          const optionValue = typeof option === 'object' ? option[valueField] : option;
          const optionLabel = typeof option === 'object' ? option[labelField] : option;
          
          return (
            <option key={key} value={optionValue} style={{color:'black'}}>
              {optionLabel}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
